import { CategoryData } from "../../component/appModels/category.model";

// GET Action
export class getCategorys {
    static readonly type = '[Category] Get';
    constructor(public payload: CategoryData) { }
}